<template>
  <div class="about">
    <Title title="About us" />
    <div class="text_container">
      <p class="text-justify par">
        Welcome to our online food delivery service! 
        Our objective is to provide quality, affordable food that you can trust. 
        We take pride in offering an experience that is both convenient and user-friendly.
        Whether you're looking for a quick meal or something more substantial, 
        we have everything you need right here on our website.<br>
        You can browse through our menus and order directly from the comfort of your own home – 
        no matter where you are located!<br><br>
        Plus, thanks to our reliable delivery system,
        there's never any reason to worry about running out of groceries! 
        Thanks for choosing us as your go-to source for delicious food – we look forward to serving YOU soon!
        Our selection of restaurants that deliver is based on a number of factors.<br><br> 
        We screen the restaurants to make sure they meet our high quality standards, 
        and that their food meets your preferences.
        The food is always fresh and delivered right to your door, 
        making it a breeze to get exactly what you need.
        Our customers are very happy with our service.<br> 
        They love not having to worry about where their next meal is coming from,
        and that their food is delivered right to their door.<br>
        <br>
        This text was generated by an AI bot.
      </p>
    </div>
    
  </div>
</template>

<script>
import Title from '@/components/Title.vue';

export default {
    name: "About",
    components: { Title }
}
</script>
<style scoped>
  body {
    font-family: 'Lato', sans-serif;
  }
  .text_container {
    margin-top: 2rem;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
  .par {
    display: inline-block;
    width: 65rem;
    font-size: 1.3rem;
    font-weight: 500;
  }
</style>
